import React, { createContext, useState } from "react";


export const StateContext = createContext();

const StateProvider = ({ children }) => {
  const [searchValue, setSearchValue] = useState("");
 
  const authInfo = {
    searchValue,
    setSearchValue,
  };
  return (
    <StateContext.Provider value={authInfo}>{children}</StateContext.Provider>
  );
};

export default StateProvider;
